import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react"; // Icône de flèche

const MesPaiements = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100">
      

      {/* Flèche de retour */}
      <div className="p-4">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center text-blue-600 hover:text-blue-800 font-semibold"
        >
          <ArrowLeft size={24} className="mr-2" />
          Retour
        </button>
      </div>

      {/* Contenu principal */}
      <div className="flex justify-center mt-6">
        <div className="w-full max-w-lg bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">Mes Paiements</h1>

          <div className="space-y-4">
            <div className="bg-gray-100 p-4 rounded-lg shadow-sm">
              <p className="text-gray-700 font-semibold">Facture #12345</p>
              <p className="text-gray-500">Montant : 50€ - Statut : Payé ✅</p>
            </div>

            <div className="bg-gray-100 p-4 rounded-lg shadow-sm">
              <p className="text-gray-700 font-semibold">Facture #12346</p>
              <p className="text-gray-500">Montant : 30€ - Statut : En attente ⏳</p>
            </div>

            <div className="bg-gray-100 p-4 rounded-lg shadow-sm">
              <p className="text-gray-700 font-semibold">Facture #12347</p>
              <p className="text-gray-500">Montant : 100€ - Statut : Payé ✅</p>
            </div>

            <button className="w-full bg-blue-500 text-white py-3 rounded-md text-lg font-semibold hover:bg-blue-600 transition">
              Effectuer un paiement
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MesPaiements;
